// extracted by mini-css-extract-plugin
export var orderSummary = "_re-0";
export var showMoreLessButton = "_re-1";